/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import { gql } from 'urql';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type UpdateCustomerInput = {
  readonly birthday?: string | null | undefined;
  readonly contactNumber?: string | null | undefined;
  readonly firstName?: string | null | undefined;
  readonly lastName?: string | null | undefined;
  /** @deprecated The password field will not be used with the new password-less flow. */
  readonly password?: string | null | undefined;
  readonly zipCode?: string | null | undefined;
};

export type UpdateCustomerProfileMutationVariables = Exact<{
  input: Types.UpdateCustomerInput;
}>;

export type UpdateCustomerProfileMutation = {
  readonly updateCustomer: {
    readonly __typename: 'UpdateCustomerResponse';
    readonly customer: {
      readonly __typename: 'Customer';
      readonly id: string;
      readonly firstName: string | null;
      readonly lastName: string | null;
      readonly email: string | null;
      readonly phoneNumber: string | null;
      readonly zipCode: string | null;
      readonly birthday: string | null;
    };
  } | null;
};

export type CustomerProfileFieldsQueryVariables = Exact<{ [key: string]: never }>;

export type CustomerProfileFieldsQuery = {
  readonly currentCustomer: {
    readonly __typename: 'Customer';
    readonly id: string;
    readonly firstName: string | null;
    readonly lastName: string | null;
    readonly email: string | null;
    readonly phoneNumber: string | null;
    readonly zipCode: string | null;
    readonly birthday: string | null;
  } | null;
};

export const UpdateCustomerProfileDocument = gql`
  mutation UpdateCustomerProfile($input: UpdateCustomerInput!) {
    updateCustomer(input: $input) {
      __typename
      customer {
        id
        firstName
        lastName
        email
        phoneNumber
        zipCode
        birthday
        __typename
      }
    }
  }
`;

export function useUpdateCustomerProfileMutation() {
  return Urql.useMutation<UpdateCustomerProfileMutation, UpdateCustomerProfileMutationVariables>(
    UpdateCustomerProfileDocument,
  );
}
export const CustomerProfileFieldsDocument = gql`
  query CustomerProfileFields {
    currentCustomer {
      id
      firstName
      lastName
      email
      phoneNumber
      zipCode
      birthday
      __typename
    }
  }
`;

export function useCustomerProfileFieldsQuery(
  options?: Omit<Urql.UseQueryArgs<CustomerProfileFieldsQueryVariables>, 'query'>,
) {
  return Urql.useQuery<CustomerProfileFieldsQuery, CustomerProfileFieldsQueryVariables>({
    query: CustomerProfileFieldsDocument,
    ...options,
  });
}
